import { render, staticRenderFns } from "./OfferMetaAttributes.vue?vue&type=template&id=20528c98&scoped=true"
import script from "./OfferMetaAttributes.vue?vue&type=script&lang=js"
export * from "./OfferMetaAttributes.vue?vue&type=script&lang=js"
import style0 from "./OfferMetaAttributes.vue?vue&type=style&index=0&id=20528c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20528c98",
  null
  
)

export default component.exports